import { render, staticRenderFns } from "./CalldataDecode.vue?vue&type=template&id=04823f28&scoped=true&"
import script from "./CalldataDecode.vue?vue&type=script&lang=js&"
export * from "./CalldataDecode.vue?vue&type=script&lang=js&"
import style0 from "./CalldataDecode.vue?vue&type=style&index=0&id=04823f28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04823f28",
  null
  
)

export default component.exports